import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { moduleManager } from 'redux/action/modules';
import Popup from 'popup/Popup';
import { useForm } from 'react-hook-form';
import { customAxiosPostFunction } from 'utils/axiosFunction';
import AreaInfoEditPopupContainer from './AreaInfoEditPopup.css';

const AreaInfoEditPopup = ({ moduleIdx, modelNm, areaNo, areaNm, statusPopupOn, setStatusPopupOn }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const loginStatus = useSelector((store) => store.loginManager.status);
  const { register, handleSubmit, errors } = useForm();
  const confirmColumns = (data) => {
    customAxiosPostFunction(history, '/api/module/update/area', { ...data, moduleIdx }).then(() => {
      setStatusPopupOn(false);
      dispatch(moduleManager(loginStatus.authIdx));
    });
  };

  return (
    <Popup
      modal
      closeOnDocumentClick
      open={statusPopupOn}
      onClose={() => {
        setStatusPopupOn(false);
      }}
    >
      <AreaInfoEditPopupContainer>
        <form onSubmit={handleSubmit(confirmColumns)}>
          <div>
            <div className="info-column">감지기No :</div> <div className="info-value">{modelNm}</div>
          </div>
          <div>
            <div className="info-column">설비번호 :</div>{' '}
            <div className="info-value">
              <input type="text" name="areaNo" ref={register()} defaultValue={areaNo} />
            </div>
          </div>
          <div>
            <div className="info-column">설비명 :</div>{' '}
            <div className="info-value">
              <input type="text" name="areaNm" ref={register()} defaultValue={areaNm} />
            </div>
          </div>
          <div className="btn-box">
            <button type="submit" className="btn btn-success">
              저장
            </button>
          </div>
        </form>
      </AreaInfoEditPopupContainer>
    </Popup>
  );
};

export default AreaInfoEditPopup;
